// extracted by mini-css-extract-plugin
export default {"tabBar":"style_tabBar__UUG+8","tab":"style_tab__7VgBA","activeTab":"style_activeTab__UMbUV"};